<template>
  <div>
    <div class="page f-pr">
      <img src="../assets/bg-1.webp" alt="">
	  <div class="logo-fff">
		  <img src="../assets/logo-fff.png" alt="" />
	  </div>
	  <div class="foot-tips">
		  打卡规则：<br>
		  1.完成任意摊位互动任务，即可获得摊位所属电子印章！<br>
		  2.集满7枚电子印章后，可领取大礼包哦，快来解锁福利吧！
	  </div>
      <div class="btn-back" @click="back()"></div>




      <!-- 13个印章 -->

      <div class="box-item box-item-1" :class="{ 'light': taskConfig.yz1.status }" @click="openPopup(taskConfig.yz1,0)">
		<img src="../assets/1-2.png" alt="" class="img2" v-if="taskConfig.yz1.status">
        <img src="../assets/1-1.png" alt="" class="img2" v-else>
      </div>
      <div class="box-item box-item-2" :class="{ 'light': taskConfig.yz2.status }" @click="openPopup(taskConfig.yz2,1)">
       <img src="../assets/2-2.png" alt="" class="img2" v-if="taskConfig.yz2.status">
       <img src="../assets/2-1.png" alt="" class="img2" v-else>
      </div>
      <div class="box-item box-item-3" :class="{ 'light': taskConfig.yz3.status }" @click="openPopup(taskConfig.yz3,2)">
        <img src="../assets/3-2.png" alt="" class="img2" v-if="taskConfig.yz3.status">
        <img src="../assets/3-1.png" alt="" class="img2" v-else>
      </div>
      <div class="box-item box-item-4" :class="{ 'light': taskConfig.yz4.status }" @click="openPopup(taskConfig.yz4,3)">
        <img src="../assets/4-2.png" alt="" class="img2" v-if="taskConfig.yz4.status">
        <img src="../assets/4-1.png" alt="" class="img2" v-else>
      </div>
      <div class="box-item box-item-5" :class="{ 'light': taskConfig.yz5.status }" @click="openPopup(taskConfig.yz5,4)">
        <img src="../assets/5-2.png" alt="" class="img2" v-if="taskConfig.yz5.status">
        <img src="../assets/5-1.png" alt="" class="img2" v-else>
      </div>
      <div class="box-item box-item-6" :class="{ 'light': taskConfig.yz6.status }" @click="openPopup(taskConfig.yz6,5)">
        <img src="../assets/6-2.png" alt="" class="img2" v-if="taskConfig.yz6.status">
        <img src="../assets/6-1.png" alt="" class="img2" v-else>
      </div>
      <div class="box-item box-item-7" :class="{ 'light': taskConfig.yz7.status }" @click="openPopup(taskConfig.yz7,6)">
        <img src="../assets/7-2.png" alt="" class="img2" v-if="taskConfig.yz7.status">
        <img src="../assets/7-1.png" alt="" class="img2" v-else>
      </div>



      <van-overlay :show="showLoading" z-index="999">
        <div class="fcc-h " style="height: 100vh;">
          <van-loading size="24px" vertical color="#fff">加载中...</van-loading>
        </div>
      </van-overlay>

      <van-overlay :show="showPopSign" z-index="999" @click="showPopSign = !showPopSign" @touchstart="handleTouchStart">
        <div class="fcc-h gz-pop" style="height: 100vh; overflow: auto;">
          <div class="f-pr gz-pop-con fcc-h" @click.stop=''>
            <div class="fcc">
              <!-- <img src="../assets/yqjzb.png" alt="" class="img1"> -->
            </div>



            <!-- 盖章区域 -->
            <div class="gz-area fcc-h ">
              <div>

                <img src="../assets/1-2.png" alt="" class="img-5-1" v-if="dkIndex == 0">
                <img src="../assets/2-2.png" alt="" class="img-2-1" v-if="dkIndex == 1">

                <img src="../assets/3-2.png" alt="" class="img-3-1" v-if="dkIndex == 2">
                <img src="../assets/4-2.png" alt="" class="img-4-1" v-if="dkIndex == 3">


                <img src="../assets/5-2.png" alt="" class="img-1-1"  v-if="dkIndex == 4">
                <img src="../assets/6-2.png" alt="" class="img-3-2" v-if="dkIndex == 5">


                <img src="../assets/7-2.png" alt="" class="img-2-2" v-if="dkIndex == 6">


              </div>
              <img src="../assets/btn-gz.png" alt="" class="gz-area-btn">
            </div>


            <!-- <div class="gz-tips fcc">
              <img src="../assets/zcgz.png" alt="">
            </div> -->
            <div class="fix-btn" @click="showPopSign = !showPopSign">

              <!-- <van-icon name="cross" size="36" color="#fff" /> -->
            </div>
          </div>
        </div>
      </van-overlay>


      <div style="position:fixed;left: 110%;top: 110%;width: 0;height: 0;overflow: hidden">
        <audio id="audioID" ref="audio" class="aud">
          <source src="https://youxi.warnny.com/duang.mp3" type="audio/mp3" />
        </audio>
      </div>


    </div>
  </div>
</template>

<script>


import {checkTask, login} from "@/api/api";
import CryptoJS from 'crypto-js'
import {check} from "@/utils/check";
import axios from "axios";
export default {
  data() {
    return {
      dkIndex:0,

      showLoading: false,
      showPopSign: false,
      showGift: false,
      showGiftImg: 0,
      userInfo: {},
      uid: null,

      taskConfig: {
        yz1: {
          name: "yz1",
          status: false
        },
        yz2: {
          name: "yz2",
          status: false
        },
        yz3: {
          name: "yz3",
          status: false
        },
        yz4: {
          name: "yz4",
          status: false
        },
        yz5: {
          name: "yz5",
          status: false
        },
        yz6: {
          name: "yz6",
          status: false
        },
        yz7: {
          name: "yz7",
          status: false
        }
      },
      currentItem: {},
      command: ''
    }
  },

  async mounted() {
    let self = this
    self.showLoading = true
    this.uid = window.localStorage.getItem('uid')
    // this.uid = "13666666666"
    if (this.uid && this.uid != 'null' && this.uid != 'undefinded') {
      this.login(this.uid)
    } else {
      this.$router.push({ path: '/' })
      return
    }
    this.$nextTick(() => {
      let Media = document.getElementById("audioID");
      Media.src = "https://youxi.warnny.com/duang.mp3";
    })
  },

  methods: {
    login(uid) {
      let self = this
      self.showLoading = true
      login({
        username: uid
      }).then(res => {
        if (res.status != 200) {
          this.$toast(res.msg)
          // uid格式不合理，清理后显示登录框
          console.warn('检测到无效的uid格式，已清理本地数据')
          this.clearLocalStorage()
          this.$router.push({ path: '/' })
          return
        } else {
          window.localStorage.setItem('uid', res.data.userInfo.username)
          self.uid = res.data.userInfo.username
          self.userInfo = res.data.userInfo
          let taskList = res.data.userInfo.taskList
          // if (taskList.length == 0) {
          //   if (self.userInfo.checkSum >= 40) {
          //     self.showGiftImg = 0
          //     self.showGift = true
          //   }
          // }
          for (let i = 0; i < taskList.length; i++) {
            self.taskConfig[taskList[i].taskName].status = true
          }
        }
      }).finally(f => {
        self.showLoading = false
      })
    },
    openPopup(item,dkIndex) {
      console.log(item)
      this.dkIndex=dkIndex
      this.currentItem = item
      if (this.currentItem.status) {
        return
      }
      this.showPopSign = true
    },
    // 清理本地存储数据
    clearLocalStorage(){
      window.localStorage.removeItem('uid')
      console.log('已清理本地存储数据')
    },
    async gaizhang(data) {
      try {
        const response = await axios.post('https://seal-api.warnny.com/api/check/verifyV3', data, {
          headers: {
            'Content-Type': 'application/json'
          }
        });
        return response.data; // 返回接口响应数据
      } catch (error) {
        console.error('请求失败:', error);
        throw error;
      }
    },
    async handleTouchStart(event) {
      console.log("event===>>",event.touches)
      let that = this;
      if (that.currentItem.status) {
        return
      }
      if (event.touches.length != 4) {
        return
      }
      // if (this.gaizhangCount > 5) {
      //   that.$toast("盖章失败次数达5次，请输入口令")
      //   return
      // }
      let timestamp = new Date().getTime();
      // 获取触摸点的坐标
      let touchArr = []
      for (let i = 0; i < event.touches.length; i++) {
        var touchX = event.touches[i].clientX;
        var touchY = event.touches[i].clientY;
        let touchItem = [touchX, touchY]
        touchArr.push(touchItem)
      }
      let scope = check(touchArr)
      // let scope = true
      console.log(scope)
      // let scope = true
      if (!scope) {
        // that.$toast("打卡失败，请重试")
        return
      }
      if (scope) {
        if (this.checking) {
          return
        }
        this.checking = true
        let points = JSON.stringify(touchArr)
        console.log("points", touchArr)
        const requestData = {
          requestId: Date.now().toString(),
          points: touchArr,
          ukey: 'S099'
        };
        console.log("盖章请求接口参数", requestData)
        let res = await that.gaizhang(requestData)
        console.log("盖章请求接口返回", res)
        if (res.data.verified) {
          if (res.data.results[0]) {
            if (res.data.results[0].totalScore > 70){
              console.log("盖章校验通过")
            } else {
              that.$toast("打卡失败，请重试")
              this.checking = false
              return
            }
          }
        }else{
          // that.gaizhangCount++
          that.$toast("打卡失败，请重试")
          this.checking = false
          return
        }
        // this.gaizhangCount = 0
        //时间戳
        let request = {
          taskName: that.currentItem.name,
          timestamp: timestamp,
          userId: this.uid,
          type: this.type
        }
        let md5Result = CryptoJS.MD5(request.taskName + request.timestamp + request.userId).toString();
        request.sign = md5Result
        request.method = 1
        checkTask(request).then(res => {
          if (res && res.msg) {
            this.$toast(res.msg)
            this.checking = false
          } else if (res) {
            that.showPopSign = false
            that.$toast("打卡成功")
            document.querySelector('audio').play()
            document.getElementById("audioID").play()
            this.checking = false
            setTimeout(function () {
              that.login(that.uid)
            }, 1200)
          } else {
            if (res.msg) {
              that.$toast("打卡失败，请重试")
              this.checking = false
            }
          }
        })
      }
    },
  }



}
</script>
<style scoped lang="less">
	.logo-fff{
		position: absolute;
		 width: 160px;
		 left: 64px;
		 top: 50px;
		 img{
			 display: block;
			 width: 100%;
		 }
	}
.page {
  display: block;

  min-height: 100vh;
  background: #FFE5EE url(../assets/bg.webp) center 0 no-repeat;
  background-size: cover;
  // background-size: cover;
  position: relative;

  >img {
    display: block;
    width: 100%;
  }
}

.btn-back {
  position: absolute;
  left: 0;
  top: 0;
  width: 210px;
  height: 120px;
  // background: rgba(255, 0, 0, 0.5);
  z-index: 10;
}

.gz-area {
  width: 700px;

  img {
    width: 558px;
    height: 485px;
    object-fit: contain;
  }







  .gz-area-btn{
    width: 454px;
    height: 84px;
    margin-top: 35px;
  }
}

.box-item {
  position: absolute;
  z-index: 5;
  width: 255px;
  height: 230px;



  left: 0;
  top: 5%;
  // border: 1px dashed #B8B7B9;
  img {
    display: block;

    width: 100%;
    display: block;
    height: 100%;
    object-fit: contain;
  }
	 // 图片变灰色
	  // filter: grayscale(100%);
	  // opacity: .9;

	  // &.light {
	  //   filter: grayscale(0%);
	  //   opacity: 1;
	  // }
  .img2{
    // display: none;
  }
  &.light {

  }

  &-1 {

    left: 78px;
    top: 519px;
    width: 255px;
    height: 230px;


  }


  &-2 {


    left: 408px;
    top: 675px;
    width: 255px;
    height: 230px;

  }




   &-3{

    left: 64px;
    top: 803px;
    width: 255px;
    height: 230px;

  }


  &-4{

	  left: 435px;
	  top: 949px;
	  width: 255px;
	  height: 230px;


  }

  &-5{

  left: 64px;
  top: 1090px;
 width: 255px;
 height: 230px;

  }

  &-6{

  left: 413px;
  top: 1233px;
	 width: 255px;
	 height: 230px;
  }

  &-7{

  left:66px;
  top: 1379px;
 width: 255px;
 height: 230px;
  }


}


.foot-tips{
	position: absolute;
	font-size: 20px;
	line-height: 30px;
	left: 78px;
	right: 20px;
	top: 1700px;
	color: #fff;
}
.gif-img {
  width: 510px;
  display: block;
}

.gif-x {
  width: 80px;
  height: 100px;
  // background: rgb(255, 0, 0);
  position: absolute;
  right: 0;
  top: 20px;
  opacity: .5;
}
</style>
